import React from "react";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

 

const HeadingWithButton = ({ doc }) => {
  const {
    heading,
    button_text,
    internal_link_id,
    url: { url, target },
  } = doc?.primary || {};
  return (
    <div className="mt-md-5 mt-4 mb-5 heading-with-button-slice prismic-slice">
      {internal_link_id && (
        <span
          id={internal_link_id}
          className="scroll-point position-relative d-block"
        ></span>
      )}
      <div className="container">
        <div className="row position-relative align-items-center">
          {checkContentPresence(heading) && (
            <div className="col-5 col-md-8 sns-h2 pt-md-0 pt-2 text-theme-primary same-size-title">
              {textResolver(heading)}
            </div>
          )}
          <div className="col-7 col-md-4 text-right button-block">
            {url && (
              <PrismicLinkTag
                urlText={button_text}
                url={url}
                target={target}
                className="px-4 px-md-5 py-3 d-inline-block text-white font-weight-bold text-center no-underline text-uppercase text-break ls-3 button-program-green button-marketing"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeadingWithButton;